import { getDatabase, ref } from "firebase/database";

import { initializeApp as firebaseInit } from "firebase/app";

const app = firebaseInit(
    {
        apiKey: "AAAAA7A7itc:APA91bGk0ZafnCxTD40Mp7_hJyHiFp9UY23Ie0Aeb2_bOiviiB85Ong7yqYUu-cn012aM3jWFakPDBgeUItjVVQyGNjL-eJm5liuBrQ2noX3KrgnpaBqmoAbCQmuSgC6cJaHTa64HNEm",
        authDomain: "crmv2-helpdesk-default-rtdb.firebaseio.com",
        databaseURL: "https://crmv2-helpdesk-default-rtdb.firebaseio.com/",
        storageBucket: "",
    },
    `firebaseHelpDeskInstanceAt${Date.now()}`
);
const db = getDatabase(app);

function formatTelToFirebase(tel: string) {
    return `whatsapp:+${tel?.replace(/\D/g, "")}` || "";
}

export function getChatsRef(
    idOrg: string,
    numeroEquipe: string,
    NumeroCliente?: string
) {
    return ref(
        db,
        `${idOrg}/WHATSAPP/${formatTelToFirebase(numeroEquipe)}/CHATS/${
            NumeroCliente ? formatTelToFirebase(NumeroCliente) : ""
        }`
    );
}
export function getConversaRef(
    idOrg: string,
    numeroEquipe: string,
    NumeroCliente: string
) {
    return ref(
        db,
        `${idOrg}/WHATSAPP/${formatTelToFirebase(
            numeroEquipe
        )}/MENSAGENS/${formatTelToFirebase(NumeroCliente)}`
    );
}
export function getOnlineRef(idOrg: string) {
    return ref(db, `${idOrg}/EQUIPES_ATENDIMENTOS/`);
}
export function goOnlineRef(idOrg: string, idEquipe: number, idUser: number) {
    return ref(
        db,
        `${idOrg}/EQUIPES_ATENDIMENTOS/${idEquipe}/USUARIOS/${idUser}`
    );
}
